import styled from 'styled-components';

export const $CustomMessagesActions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
